export default (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M5 2C3.34315 2 2 3.34315 2 5V18.5C2 20.1569 3.34315 21.5 5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5C21.5 3.34315 20.1569 2 18.5 2H5ZM17.7635 9.57623C18.2198 9.15455 18.2479 8.44279 17.8262 7.98647C17.4045 7.53016 16.6928 7.50209 16.2365 7.92377L9.69565 13.9682L7.26353 11.7206C6.80721 11.299 6.09545 11.327 5.67377 11.7833C5.25209 12.2397 5.28016 12.9514 5.73648 13.3731L8.93213 16.3262C9.3632 16.7246 10.0281 16.7246 10.4592 16.3262L17.7635 9.57623Z"
    fill="currentColor"
  />
);
